// -*- mode: rjsx -*-
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, unwrapResult } from 'react-redux';

import { List } from "./List.jsx";

import { loadClaimed, selectClaimedRequests } from '../../queue';

function ClaimedList(props) {
    
    const dispatch = useDispatch();
    const tasks = useSelector(selectClaimedRequests);
//    console.log("unclaimed regular list tasks: %o", tasks);

    function _load(dispatch, cursor) {
		dispatch(loadClaimed(cursor)).then((data) => {
            if(data.type == "queue/loadClaimed/fulfilled") {
                if(data.payload.next_page) {
                    _load(dispatch, data.payload.next_page);
                }
            }
        });
    }

	useEffect(() => {
        _load(dispatch, "");
    }, [dispatch]);

	return <List tasks={tasks}  queue={props.queue} />;
}

export { ClaimedList };



